import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { BreadcrumbsModule } from "src/app/components/elementi-strutturali/breadcrumbs/breadcrumbs.module";
import { PageLayoutComponent } from "./page-layout.component";

@NgModule({
  imports: [CommonModule,BreadcrumbsModule],
  declarations: [PageLayoutComponent],
  exports: [PageLayoutComponent],

})
export class PageLayoutModule {
  static component = PageLayoutComponent
}